var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "columns is-gapless" }, [
      _c("div", { staticClass: "column" }, [
        _c("div", { staticClass: "field" }, [
          _c("div", { staticClass: "field is-horizontal" }, [
            _c("div", { staticClass: "field-body" }, [
              _c("div", { staticClass: "field-body" }, [
                _c("div", { staticClass: "field has-addons" }, [
                  _c(
                    "div",
                    { staticClass: "control has-icons-left has-icons-right" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.filter.query,
                            expression: "filter.query",
                          },
                        ],
                        staticClass: "input",
                        attrs: {
                          type: "text",
                          placeholder: "Start typing to filter",
                        },
                        domProps: { value: _vm.filter.query },
                        on: {
                          input: [
                            function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(_vm.filter, "query", $event.target.value)
                            },
                            _vm.search,
                          ],
                        },
                      }),
                      _vm._m(0),
                    ]
                  ),
                  _c("div", { staticClass: "control" }, [
                    _c(
                      "a",
                      {
                        staticClass: "button is-primary is-outlined tooltip",
                        attrs: { "data-tooltip": "Reset search" },
                        on: {
                          click: function ($event) {
                            return _vm.reset()
                          },
                        },
                      },
                      [_vm._m(1)]
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "table-container-avaialble-butterfly-items" },
      [
        _c(
          "bulma-table",
          {
            staticClass: "table is-striped is-narrow is-fullwidth",
            attrs: {
              columns: _vm.columns,
              "has-sticky-header": true,
              "page-index": _vm.filter.pageIndex,
              "page-size": _vm.filter.pageSize,
              "total-rows": _vm.totalRows,
              "is-loading": _vm.isTableLoading,
              "sort-column": _vm.filter.sortColumn,
              "sort-order": _vm.filter.sortOrder,
            },
            on: { pageChanged: _vm.onPageChange, sort: _vm.sort },
          },
          [
            _vm._l(_vm.availableItems, function (item, index) {
              return _c("tr", { key: index }, [
                _c("td", [_vm._v(_vm._s(item.itemNo))]),
                _c(
                  "td",
                  {
                    on: {
                      dblclick: function ($event) {
                        return _vm.addNewItems(item, index)
                      },
                    },
                  },
                  [_vm._v(_vm._s(item.description))]
                ),
                _c(
                  "td",
                  {
                    staticClass: "has-text-right mr-2",
                    on: {
                      click: function ($event) {
                        return _vm.addSingleNewItem(
                          item,
                          _vm.itemCategoryTypes.MECH,
                          true
                        )
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "butterfly-item-values is-flex is-justify-content-center",
                        class: {
                          " has-text-weight-bold is-selected": _vm.findItem(
                            item,
                            _vm.itemCategoryTypes.MECH
                          ),
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$filters.formatNumber(
                                _vm.getDisplayValue(
                                  _vm.itemCategoryTypes.MECH,
                                  item.mechHour
                                ),
                                _vm.$userInfo.locale
                              )
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ]
                ),
              ])
            }),
            _c("template", { slot: "empty" }, [
              _c("section", { staticClass: "section" }, [
                _c(
                  "div",
                  { staticClass: "content has-text-grey has-text-centered" },
                  [
                    _c("span", { attrs: { icon: "icon is-large" } }, [
                      _c("i", { staticClass: "mdi mdi-48px mdi-car-off" }),
                    ]),
                    _c("p", [
                      _vm._v("There are no custom items in your list."),
                    ]),
                    _c("p", [
                      _vm._v(
                        "To Add your own please go to Tables > Other Labour > Mechanical"
                      ),
                    ]),
                    _c("p", [_vm._v("and create new Mechanical items.")]),
                  ]
                ),
              ]),
            ]),
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-left" }, [
      _c("i", { staticClass: "mdi mdi-magnify mdi-18px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-close mdi-24px" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }